// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__i7OHk","modal-show":"Modal_modal-show__0+jR3","openModal":"Modal_openModal__QRzXe","modal-bg-show":"Modal_modal-bg-show__u0dXO"};